import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { useQueryCourseGames } from 'gql/queries/course';
import {
  mutationEditorReset,
  mutationEditorGameCreate,
} from 'gql/mutations/editor';

import Games from './Games';

const GamesContainer = (props) => {
  const { t } = useTranslation();
  const { courseId } = useParams();
  const { isLoading, data } = useQueryCourseGames({
    variables: {
      courseId,
    },
  });
  const isEmpty = isLoading ? false : data.course.games.length === 0;
  useEffect(() => {
    mutationEditorReset();
    return () => {
      mutationEditorReset();
    };
  }, []);
  return (
    <Games
      course={data?.course}
      handleGameCreate={mutationEditorGameCreate}
      isEmpty={isEmpty}
      isLoading={isLoading}
      t={t}
      {...props}
    />
  );
};

export default GamesContainer;
